import { isFilterValueEmpty } from "app/pages/sales-intelligence/domain/search/utils/is-filter-value-empty";
import { leadsFilterDtoToPanelValue } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/leadsFilterDtoAdapters";
import { isLeadsPanelFilterAtProductDefault } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/leadsPanelFilterProductDefault";

import type { TeamFilters } from "../types/teams.types";

const hasMeaningfulPanelFilters = (filters: TeamFilters): boolean => {
    const panelValue = leadsFilterDtoToPanelValue(filters) as Record<string, unknown>;

    return Object.entries(panelValue).some(
        ([key, value]) => !isFilterValueEmpty(value) && !isLeadsPanelFilterAtProductDefault(key, value),
    );
};

/**
 * A team only contributes a "territory" if it actually has filters configured. Teams with no
 * filters are irrelevant to "My territory filters" — they're excluded from selection and from the
 * dropdown (so a user with one filtered team + one empty team sees no dropdown).
 */
export const teamHasFilters = (filters: TeamFilters | undefined): boolean =>
    !!filters && hasMeaningfulPanelFilters(filters);
